// extracted by mini-css-extract-plugin
module.exports = {"container":"StarRating_container__qvxQY"};